import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { searchProduct, changeCategory } from "../store/actions/productActions";
import { logAction, A } from "./AdminLogger";
import CategoryList from "./CategoryList";
import { ThemeSelectorWrapper } from "./ThemeSelector";
import { useTheme } from "../context/ThemeContext";
import { getTheme } from "../config/themes";
import axios from "axios";
import { API } from "../config/api";
import { SETTINGS_JSON_URL, LOGO_URL, BRAND_NAME, CONTACT_EMAIL, INSTAGRAM_URL, INSTAGRAM_HANDLE } from "../config/domain";

// ── Settings — завжди з sheet-settings.json ─────────────
// Завантажується один раз при старті сторінки
window._bvS = null;

const TAGLINE_WORDS = ["PRODUCE", "WHOLESALE", "FRESH"];
const PROFILE_API = API.profile;

class Header extends Component {
  state = {
    _phone: '',
    tagIndex: 0,
    showLogo: true,
    brandFading: false,
    searchText: "",
    searchDeleting: false,
    searchWord: "",
    searchWords: [],
    searchFocused: false,
    searchValue: "",
    showInfo: false,
    profileBadge: null,

  };

  // Safe localStorage helper
  _ls(key, val) {
    try {
      if (val === undefined) return localStorage.getItem(key);
      if (val === null) { localStorage.removeItem(key); return null; }
      localStorage.setItem(key, val);
    } catch { return null; }
  }

  componentDidMount() {
    fetch(SETTINGS_JSON_URL + '?t=' + Date.now())
      .then(r => { if (!r.ok) throw new Error('settings_' + r.status); return r.json(); })
      .then(data => {
        window._bvS = data;
        this.setState({ _phone: data.phone || '' });
        window.dispatchEvent(new Event('bv_settings_updated'));
      })
      .catch(() => { /* silent — non-critical prefetch */ });

    // Текст крутиться швидко
    this.tagInterval = setInterval(() => {
      this.setState(prev => ({ tagIndex: (prev.tagIndex + 1) % TAGLINE_WORDS.length }));
    }, 2200);

    // Кожні 10 сек — fade лого ↔ текст
    this.brandInterval = setInterval(() => {
      this.setState({ brandFading: true });
      setTimeout(() => {
        this.setState(prev => ({ showLogo: !prev.showLogo, brandFading: false }));
      }, 400);
    }, 10000);

    // Читаємо badge з localStorage
    this.loadProfileBadge();
    // Завантажуємо актуальні settings з сервера
    this.badgeInterval = setInterval(() => this.loadProfileBadge(), 30000);
    // Слухаємо зміни profileBadge з Profile.js (оновлюється після кожного завантаження)
    this._onStorage = (e) => { if (!e.key || e.key === "profileBadge") this.loadProfileBadge(); };
    window.addEventListener("storage", this._onStorage);
    // CustomEvent від Profile.js (той самий таб) — StorageEvent не спрацьовує в тому ж вікні
    this._onBadgeUpdate = () => this.loadProfileBadge();
    window.addEventListener("bv_profile_badge_updated", this._onBadgeUpdate);

    // Prefetch профілю у фоні щоб Profile відкривався миттєво
    this.prefetchProfile();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.products !== this.props.products) {
      this.prepareSearchWords();
    }
  }



  componentWillUnmount() {
    clearInterval(this.tagInterval);
    clearInterval(this.brandInterval);
    clearInterval(this.badgeInterval);
    clearTimeout(this.searchTimeout);
    if (this._onStorage) window.removeEventListener("storage", this._onStorage);
    if (this._onBadgeUpdate) window.removeEventListener("bv_profile_badge_updated", this._onBadgeUpdate);
    if (this._abortCtrl) this._abortCtrl.abort();
  }

  loadProfileBadge = () => {
    const email = this._ls("userEmail");
    if (!email) { this.setState({ profileBadge: null }); return; }
    try {
      const raw = this._ls("profileBadge");
      this.setState({ profileBadge: raw ? (()=>{ try { return JSON.parse(raw); } catch { return null; } })() : null });
    } catch(e) { this.setState({ profileBadge: null }); }
  };

  prefetchProfile = () => {
    const email = this._ls("userEmail");
    if (!email) return;
    // Тільки якщо кеш старший за 5 хвилин або відсутній
    try {
      const cached = this._ls("profileCache");
      const ts = this._ls("profileCacheTs");
      if (cached && ts && (Date.now() - Number(ts)) < 5 * 60 * 1000) return;
    } catch(e) {}
    axios.post(PROFILE_API, { email }).then(res => {
      if (res.data && res.data.success) {
        this._ls("profileCache", JSON.stringify(res.data));
        this._ls("profileCacheTs", String(Date.now()));
        const invoices = res.data.invoices || [];
        const processing = invoices.filter(i => (i.status||"").toUpperCase() === "PROCESSING").length;
        const unpaid     = invoices.filter(i => (i.status||"").toUpperCase() === "UNPAID").length;
        const pricing    = invoices.filter(i => (i.status||"").toUpperCase() === "PRICING").length;
        this._ls("profileBadge", JSON.stringify({ processing, unpaid, pricing }));
        this.loadProfileBadge();
      } else if (res.data && !res.data.success) {
        // Кастомера видалено — очищаємо кеш але НЕ редіректимо автоматично
        // (редірект має відбуватись тільки при явній дії юзера, напр. в Profile.js)
        this._ls("profileCache", null);
        this._ls("profileCacheTs", null);
        this._ls("profileBadge", null);
        this.loadProfileBadge();
      }
    }).catch(() => { /* silent */ });
  };

  prepareSearchWords = () => {
    const { products } = this.props;
    if (!products || products.length === 0) return;
    const words = products.map((p) => p.name).filter(Boolean);
    const first = words[Math.floor(Math.random() * words.length)];
    this.setState({ searchWords: words, searchWord: first }, this.typeSearch);
  };

  getRandomSearchWord = (words, current) => {
    let w = words[Math.floor(Math.random() * words.length)];
    while (w === current && words.length > 1) w = words[Math.floor(Math.random() * words.length)];
    return w;
  };

  typeSearch = () => {
    const { searchText, searchDeleting, searchWord, searchWords, searchFocused } = this.state;
    if (searchFocused || !searchWord) return;
    const speed = searchDeleting ? 40 : 80;
    const newText = searchDeleting
      ? searchWord.substring(0, searchText.length - 1)
      : searchWord.substring(0, searchText.length + 1);
    this.setState({ searchText: newText });
    if (!searchDeleting && newText === searchWord) {
      this.searchTimeout = setTimeout(() => {
        this.setState({ searchDeleting: true }, this.typeSearch);
      }, 1200);
      return;
    }
    if (searchDeleting && newText === "") {
      const next = this.getRandomSearchWord(searchWords, searchWord);
      this.setState({ searchDeleting: false, searchWord: next });
    }
    this.searchTimeout = setTimeout(this.typeSearch, speed);
  };

  handleFocus = () => {
    clearTimeout(this.searchTimeout);
    this.setState({ searchFocused: true, searchText: "" });
  };

  handleBlur = (e) => {
    if (e.target.value === "") this.setState({ searchFocused: false }, this.typeSearch);
  };

  handleSearch = (e) => {
    this.setState({ searchValue: e.target.value });
    this.props.searchProduct(e.target.value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  handleCategoryChange = (value) => {
    this.setState({ showInfo: false });
    this.props.changeCategory(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  handleCart = () => { this.setState({ showInfo: false }); this.props.navigate("/cart"); requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' })); };

  handleLoginProfile = () => {
    const email = this._ls("userEmail");
    const path = this.props.location.pathname;
    this.setState({ showInfo: false });
    if (!email) {
      this.props.navigate("/login");
      requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    } else if (path === "/profile") {
      if (window.confirm("Are you sure you want to logout?")) {
        logAction(A.LOGIN, 'user', email, `Logout: ${email}`);
        this._ls("userEmail", null);
        this.props.navigate("/");
        requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
      }
    } else {
      this.props.navigate("/profile");
      requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }
  };

  toggleInfo = () => this.setState(prev => ({ showInfo: !prev.showInfo }));

  render() {
    const { searchText, searchFocused, searchValue, showInfo, tagIndex, showLogo, brandFading } = this.state;
    const { totalItems, location } = this.props;
    const isStorePage = location.pathname === "/" || location.pathname === "/store";
    const email = this._ls("userEmail");
    const placeholder = searchFocused ? "" : (searchText || "Search...");

    const IconTruck = () => (
      <svg viewBox="0 0 24 24" fill="none">
        <rect x="1" y="3" width="15" height="13" rx="1" stroke="currentColor" strokeWidth="1.8"/>
        <path d="M16 8h4l3 4v5h-7V8z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
        <circle cx="5.5" cy="18.5" r="2.5" stroke="currentColor" strokeWidth="1.8"/>
        <circle cx="18.5" cy="18.5" r="2.5" stroke="currentColor" strokeWidth="1.8"/>
      </svg>
    );


    const IconCart = () => (
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );

    const IconSearch = () => (
      <svg viewBox="0 0 20 20" fill="none">
        <circle cx="8.5" cy="8.5" r="5.5" stroke="currentColor" strokeWidth="1.8"/>
        <path d="M13 13l3.5 3.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    );

    return (
      <>
        <header className="site-header">
          <div className="header-inner">

            {/* Logo */}
            <Link to="/" className={`brand${brandFading ? ' brand-fading' : ''}`}>
              {showLogo ? (
                <img
                  src={(this.props.activeLogo || LOGO_URL).replace(/\.webp$/, '-sm.webp')}
                  srcSet={`${(this.props.activeLogo || LOGO_URL).replace(/\.webp$/, '-sm.webp')} 1x, ${this.props.activeLogo || LOGO_URL} 2x`}
                  alt={`${window._bvS?.brandName || BRAND_NAME} logo`}
                  className="brand-logo-img"
                  width="77"
                  height="77"
                  fetchpriority="high"
                />
              ) : (
                <div className="brand-tagline-big">
                  {TAGLINE_WORDS.map((word, i) => (
                    <span
                      key={word}
                      className={`brand-tagline-word ${
                        i === tagIndex ? "active" :
                        i === (tagIndex - 1 + TAGLINE_WORDS.length) % TAGLINE_WORDS.length ? "prev" : "next"
                      }`}
                    >
                      {word}
                    </span>
                  ))}
                </div>
              )}
            </Link>

            {/* Пошук — завжди відкритий на store */}
            {isStorePage && (
              <div className="search-pill">
                <CategoryList onCategoryChange={this.handleCategoryChange} />
                <div className="search-divider" />
                <div className="search-input-wrap">
                  <IconSearch />
                  <input
                    type="search"
                    id="site-search"
                    name="site-search"
                    autoComplete="off"
                    ref={el => this._searchInput = el}
                    value={searchValue}
                    placeholder={placeholder}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    onChange={this.handleSearch}
                    className="search-input"
                  />
                  {searchValue && (
                    <button className="search-clear" aria-label="Clear search" onClick={() => {
                      this.setState({ searchValue: "" });
                      this.props.searchProduct("");
                      if (this._searchInput) this._searchInput.focus();
                    }}>×</button>
                  )}
                </div>
              </div>
            )}

            {/* Actions: Back, Info, Login, Cart */}
            <div className="header-actions">
              {!isStorePage && (
                <button
                  className="action-btn back-btn"
                  onClick={() => { this.setState({ showInfo: false }); this.props.navigate('/'); requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' })); }}
                  title="Back to Store"
                  aria-label="Back to Store"
                >
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M19 12H5M5 12l7-7M5 12l7 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              )}

              <button
                className={`action-btn info-btn ${showInfo ? "active" : ""}`}
                onClick={this.toggleInfo}
                title="Delivery Info"
                aria-label="Delivery Info"
                aria-expanded={showInfo}
              >
                <IconTruck />
                <span className="action-label">Info</span>
              </button>

              {(() => {
                const { profileBadge } = this.state;
                const badgeCount = email && profileBadge ? (profileBadge.pricing||0) + (profileBadge.processing||0) + (profileBadge.unpaid||0) : 0;
                const hasUnpaid  = email && profileBadge && profileBadge.unpaid > 0;
                const hasProcess = email && profileBadge && profileBadge.processing > 0 && profileBadge.unpaid === 0;
                return (
                  <button
                    className={`action-btn login-btn ${email ? "logged-in" : ""}`}
                    onClick={this.handleLoginProfile}
                    type="button"
                    title={email ? (this.props.location.pathname === "/profile" ? "Logout" : "Profile") : "Login"}
                  >
                    {email ? (
                      this.props.location.pathname === "/profile" ? (
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          <polyline points="16 17 21 12 16 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                        </svg>
                      ) : (
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.8"/>
                        </svg>
                      )
                    ) : (
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                        <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.8"/>
                      </svg>
                    )}
                    {badgeCount > 0 && (
                      <span className={"profile-badge" + (hasUnpaid ? " profile-badge--unpaid" : hasProcess ? " profile-badge--processing" : "")}>
                        {badgeCount}
                      </span>
                    )}
                  </button>
                );
              })()}

              <button
                className="action-btn cart-btn"
                onClick={this.handleCart}
                type="button"
                aria-label={totalItems > 0 ? `Cart, ${totalItems} item${totalItems > 1 ? 's' : ''}` : "Cart"}
              >
                <IconCart />
                {totalItems > 0 && <span className="cart-badge" aria-hidden="true">{totalItems}</span>}
              </button>

              <ThemeSelectorWrapper />
            </div>
          </div>
        </header>

        {showInfo && (
          <div className="info-panel">

            {/* Close */}
            <button className="info-close" onClick={this.toggleInfo}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              <span>Close</span>
            </button>

            {/* Page links — right after close */}
            <div className="info-links">
              {[
                { path: '/about',        label: 'About Us'     },
                { path: '/contact',      label: 'Contact'      },
                { path: '/delivery',     label: 'Delivery Info'},
                { path: '/how-it-works', label: 'How It Works' },
              ].map(({ path, label }) => (
                <button
                  key={path}
                  className="info-link-btn"
                  onClick={() => { this.setState({ showInfo: false }); this.props.navigate(path); requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' })); }}
                >
                  <span>{label}</span>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="13" height="13" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                </button>
              ))}
            </div>

            {/* 2-col grid */}
            <div className="info-grid">
              <a href={`tel:${this.state._phone}`} className="info-card info-card--link">
                <span className="info-card__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.49 10.5a19.79 19.79 0 01-3.07-8.67A2 2 0 012.4 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.08 6.08l1.28-1.28a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg></span>
                <div><p className="info-card__label">CALL · TEXT</p><p className="info-card__val">{this.state._phone ? this.state._phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : '...'}</p></div>
              </a>
              <a href={`https://wa.me/1${window._bvS?.whatsapp || this.state._phone}`} target="_blank" rel="noopener noreferrer" className="info-card info-card--whatsapp info-card--link">
                <span className="info-card__icon"><svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg></span>
                <div><p className="info-card__label">WHATSAPP</p><p className="info-card__val">Chat with us</p></div>
              </a>
              <a href={`mailto:${window._bvS?.email || CONTACT_EMAIL}`} className="info-card info-card--link">
                <span className="info-card__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg></span>
                <div><p className="info-card__label">EMAIL</p><p className="info-card__val">{window._bvS?.email || CONTACT_EMAIL}</p></div>
              </a>
              <div className="info-card">
                <span className="info-card__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></span>
                <div><p className="info-card__label">HOURS</p><p className="info-card__val">{(() => { const days = (window._bvS?.workDays||'Sun–Fri').split(',').map(d=>d.trim().slice(0,3)); return days.length > 1 ? `${days[0]}–${days[days.length-1]}` : days[0] || 'Sun–Fri'; })()} · {window._bvS?.workHours || "4AM–7PM"}</p></div>
              </div>
              <a href={`https://maps.google.com/?q=${encodeURIComponent(window._bvS?.address || "165 Queensway W, Mississauga")}`} target="_blank" rel="noopener noreferrer" className="info-card info-card--link">
                <span className="info-card__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg></span>
                <div><p className="info-card__label">ADDRESS</p><p className="info-card__val">{window._bvS?.address || "165 Queensway W, Mississauga"}</p></div>
              </a>
              <a href={window._bvS?.instagram || INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="info-card info-card--link">
                <span className="info-card__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg></span>
                <div><p className="info-card__label">INSTAGRAM</p><p className="info-card__val">{(window._bvS?.instagram || "").replace("https://www.instagram.com/","").replace("https://instagram.com/","") || `@${INSTAGRAM_HANDLE}`}</p></div>
              </a>
              <div className="info-card info-card--green">
                <span className="info-card__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg></span>
                <div><p className="info-card__label">DELIVERY</p><p className="info-card__val">Next day · ${window._bvS?.deliveryPrice || "9.99"} fee</p></div>
              </div>
              <div className="info-card info-card--green">
                <span className="info-card__icon" style={{fontSize:20}}>🌿</span>
                <div><p className="info-card__label">ORGANIC</p><p className="info-card__val">Local &amp; organic available</p></div>
              </div>
            </div>

            {/* Terms — compact single line */}
            <div className="info-terms">
              <span className="info-terms__title">TERMS</span>
              <span>1 business day delivery · {(window._bvS?.location || "Toronto,Brampton,Vaughan,Oakville,Mississauga").split(",").join(" · ")} · ${window._bvS?.deliveryPrice || "9.99"} min fee · {window._bvS?.dropoffPolicy || "House: bell · Apt: concierge"}</span>
            </div>

          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  totalItems: state.totalItems,
  products: state.products,
});

// v6: inject navigate into class component via HOC
function withNavigate(Component) {
  return function WithNavigateWrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();
    return <Component {...props} navigate={navigate} location={location} />;
  };
}
const ConnectedHeader = connect(mapStateToProps, { searchProduct, changeCategory })(withNavigate(Header));

// Wrapper щоб передати activeLogo через useTheme хук
const HeaderWithTheme = (props) => {
  const { theme } = useTheme();
  const activeLogo = getTheme(theme).logo;
  return <ConnectedHeader {...props} activeLogo={activeLogo} />;
};

export default HeaderWithTheme;
